<template>
  <div v-if="isVisible" class="modal-overlay">
    <DDialog :modelValue="isVisible" @update:modelValue="updateVisibility">
      <DCard >
        <DCardSection>
          <DFile label="Choose image" filled v-model="file" accept="image/png" @update:model-value="onFileChange" />
          <DImg :src="imagePreview" style="max-width: 500px; margin-top: 10px;" v-if="imagePreview" />
          <DInput v-if="!onlyImg" filled type="number" v-model="level" label="Level of image" placeholder="Level of image" />
        </DCardSection>

        <DCardSection align="right">
          <DButton color="primary" label="Cancel" @click="onCancelClick" />
          <DButton color="positive" label="OK" @click="onOKClick" />
        </DCardSection>
      </DCard>
    </DDialog>
  </div>
</template>

<script>
import DButton from '@components/ui/DButton.vue'
import DCard from '@components/ui/DCard.vue'
import DCardSection from '@components/ui/DCardSection.vue'
import DDialog from '@components/ui/DDialog.vue'
import DInput from '@components/ui/DInput.vue'
import DImg from '@components/ui/DImg.vue'
import DFile from '@components/ui/DFile.vue'
export default {
  components: {
    DButton,
    DCard,
    DCardSection,
    DDialog,
    DInput,
    DImg,
    DFile
  },
  data() {
    return {
      file: null,
      imagePreview: null,
      level: 1,
      name: ''
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    onlyImg: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onFileChange(fileValue) {
      const file = Array.isArray(fileValue) ? fileValue[0] : fileValue

      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.imagePreview = e.target.result
          this.name = file.name.substring(file.name.indexOf('\\', file.name.indexOf('\\') + 1) + 1, file.name.lastIndexOf('.'))
        }
        reader.readAsDataURL(file)
      } else {
        this.imagePreview = null
      }
    },
    updateVisibility(value) {
      this.$emit('update:isVisible', value)
    },

    onOKClick() {
      if (!this.file) {
        this.$emit('show-notification', 'negative', 'Please select a image')
      } else {
        this.$emit('confirm', { imagePreview: this.imagePreview, level: this.level, name: this.name })
        this.hide()
        this.imagePreview = null
      }
    },

    onCancelClick() {
      this.imagePreview = null
      this.hide()
    },
    hide() {
      this.$emit('cancel')
    }
  }
}
</script>
<style  scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>